import { render } from "./Add.vue?vue&type=template&id=75f4ef20"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=75f4ef20&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/message/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75f4ef20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75f4ef20', __exports__)) {
    console.log('reload')
    api.reload('75f4ef20', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=75f4ef20", () => {
    console.log('re-render')
    api.rerender('75f4ef20', render)
  })

}


export default __exports__